import { serverUrl, apiUrl } from '../../config/react'

function getFullUrl(route) {
  const isAbsolutePath = route.startsWith('http') || route.startsWith('https')
  if (isAbsolutePath) {
    return route
  }
  return serverUrl + apiUrl + route
}

function addAuthorizationHeader(headers) {
  const token = localStorage.getItem('access_token')
  if (typeof token === 'string') {
    Object.assign(headers, {
      Authorization: `Basic ${token}`
    })
  }
  return headers
}

function serializeData(options, data) {
  if (!!data && typeof data === 'object') {
    Object.assign(options, {
      body: JSON.stringify(data),
      headers: {
        ...options.headers,
        'Content-Type': 'application/json'
      }
    })
  }
  return options
}

function combineOption(option1, option2) {
  const combinedHeaders = Object.assign({}, option1.headers, option2.headers)
  return Object.assign({}, option1, option2, { headers: combinedHeaders })
}

// Basic request with token and serialized data
export default function request(method, route, data, defaultOptions = {}) {
  let options = {
    method,
    headers: addAuthorizationHeader({
      'media-type': 'application/json',
      'cache-control': 'no-cache'
    })
  }
  serializeData(options, data)
  // Merge created options with input options
  options = combineOption(options, defaultOptions)
  return fetch(getFullUrl(route), options)
}



// WEBPACK FOOTER //
// ./src/utils/request.js